module.exports = __webpack_public_path__ + "static/media/Montana2921.63207199.jpg";